"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  DefaultStyles = () => ({
    margin: "0",
    padding: "0"
  });

/**
 * Wrapping component for calculator questions panel
 *
 * @visibleName Calculator Questions
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const CalculatorQuestions = props => {
  const {
      className,
      children,
      componentTag = "div",
      styles = {},
      testId
    } = props,
    compositeClassNames = (0, _classnames.default)({
      "calculator__questions": true,
      [`${className}`]: className
    }),
    compositeStyles = merge(DefaultStyles(), styles);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compositeClassNames,
    component: componentTag,
    "data-testid": testId,
    sx: compositeStyles
  }, children);
};

// Define propTypes;
CalculatorQuestions.propTypes = {
  /** Children components */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Component HTML Tag (Default Value: "div") */
  componentTag: _propTypes.default.string,
  /** Styles Object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = CalculatorQuestions;